import { fromJS } from 'immutable'
import { returnStateIfNoAction } from '../helpers'
import { PROGRAM_DEFAULT } from '../../constants/state'


const INIT_STATE = fromJS(PROGRAM_DEFAULT.elbenwaldBrands)


const elbenwaldBrandsReducer = (state = INIT_STATE, action) => {

    returnStateIfNoAction(action, state)

    switch(action.type){            
        default:
            return state;
    }
}

export default elbenwaldBrandsReducer